module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_1.0cbdb5ac.png";